let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5wzlX")).then(() => parcelRequire('i9WT6'));